import { Box } from "@mui/material";

const DealInfoSidebarSkeleton = () => {
  return (
    <Box sx={{ px: 3 }}>
      {[1, 2, 3].map((i) => (
        <Box
          key={i}
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            py: 1.5,
            border: "none",
            boxShadow: "none",
          }}
        >
          <Box
            sx={{
              width: 30,
              height: 30,
              borderRadius: "50%",
              border: "none",
              boxShadow: "none",
              background:
                "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.5s infinite",
              "@keyframes shimmer": {
                "0%": { backgroundPosition: "-200% 0" },
                "100%": { backgroundPosition: "200% 0" },
              },
            }}
          />
          <Box sx={{ flex: 1 }}>
            <Box
              sx={{
                height: 14,
                width: "40%",
                borderRadius: 4,
                border: "none",
                boxShadow: "none",
                background:
                  "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                backgroundSize: "200% 100%",
                animation: "shimmer 1.5s infinite",
              }}
            />
            <Box
              sx={{
                mt: 1,
                height: 16,
                width: "80%",
                borderRadius: 4,
                border: "none",
                boxShadow: "none",
                background:
                  "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
                backgroundSize: "200% 100%",
                animation: "shimmer 1.5s infinite",
              }}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default DealInfoSidebarSkeleton;


